// --------------------------------------------------------------------------
// #28 - HEADER
//     - handles the off canvas nav
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global dataLayer */

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var $toggleNavButton = $('<span class="navigation-mobile-nav-button"></span>');
    var $contentMask = $('<span class="content-mask"></span>');
    var $innerWrapper = context.find('[data-binding="inner-wrapper"]');
    var $offCanvasNavigation = context.find('.navigation');
    var $openSearchButton = context.find('.open-search');
    var $closeSearchButton = context.find('.close-search');
    var isMobile = false;
    var hoverOutDelay = 300;
    var searchOpened = false;

    /// Set varibles for navigation delay hovers
    var hoverClass = 'hover';

    /// Timeout functions
    // TODO: could/should these timeout functions be consolidated?
    var hideTimeout;
    var resizeTimeout;

    var tabletMegaNavOpened = false;
    var tabletMegaNavOpenedLink = '';

    function getDeviceType() {
        return 768 > window.innerWidth ? 'mobile' : 992 > window.innerWidth ? 'tablet' : 'desktop';
    }

    /**
     * Add class to parent if has children (by class name)
     */
    function hasChildren(parentClass, childClass) {

        /// Find the parent
        var $items = $offCanvasNavigation.find('.' + parentClass);

        $.each($items, function () {
            var $this = $(this);

            /// If it has children
            if ($this.find('.' + childClass).length > 0) {
                $this.addClass('has-children');
            }
        });
    }

    /**
     * Trigger submenu of the mega nav
     */
    function desktopAddHover(trigger) {
        if (isMobile === false) {
            context.find('.navigation__nav-item').removeClass(hoverClass).attr('aria-hidden', 'true'); // remove any previously opened hovers
            clearTimeout(hideTimeout); // clear the pending hide
            trigger.addClass(hoverClass).attr('aria-hidden', 'false'); // activate hover
        }
    }

    /**
     * Set nav events
     */
    function setNavEvents() {
        if (isMobile === false) {
            context.find('[data-binding="navigation-item"]').off('mouseenter');
            if ('desktop' === getDeviceType()) {
                context.find('[data-binding="navigation-item"]').on({
                    mouseenter: function mouseenter() {
                        desktopAddHover($(this));
                    }
                });
            }

            context.find('[data-binding="navigation-tier-two"]').off('mouseenter');
            if ('desktop' === getDeviceType()) {
                context.find('[data-binding="navigation-tier-two"]').on({
                    mouseenter: function mouseenter() {
                        // clear the pending hide for leaving navigation bar
                        clearTimeout(hideTimeout);
                    }
                });
            }

            context.find('[data-binding="navigation"]').off('mouseenter mouseleave focusout').on({
                mouseenter: function mouseenter() {
                    // disable the slide in animation after first use
                    setTimeout(function () {
                        $offCanvasNavigation.removeClass('enable-animation').addClass('disable-animation');
                    }, 500);

                    // clear the pending hide if mouse has just left the navigation and got back to it
                    clearTimeout(hideTimeout);
                },
                mouseleave: function mouseleave() {
                    if ('desktop' === getDeviceType()) {
                        // hide the hover
                        hideTimeout = setTimeout(function () {
                            context.find('[data-binding="navigation-item"]').removeClass(hoverClass).attr('aria-hidden', 'true');
                            // enable animations after successful hover out
                            $offCanvasNavigation.removeClass('disable-animation').addClass('enable-animation');
                        }, hoverOutDelay);
                    }

                    if ('tablet' === getDeviceType()) {
                        tabletMegaNavOpened = false;
                        tabletMegaNavOpenedLink = '';
                    }
                },
                focusout: function focusout() {
                    if ('tablet' === getDeviceType()) {
                        // hide the hover
                        hideTimeout = setTimeout(function () {
                            context.find('[data-binding="navigation-item"]').removeClass(hoverClass).attr('aria-hidden', 'true');
                            // enable animations after successful hover out
                            $offCanvasNavigation.removeClass('disable-animation').addClass('enable-animation');
                        }, hoverOutDelay);
                    }
                }
            });

            context.find('[data-binding="navigation-tier-two"]').off('click');
            if ('tablet' === getDeviceType()) {
                context.find('[data-binding="navigation-tier-two"]').on({
                    click: function click() {
                        // clear the pending hide for leaving navigation bar
                        clearTimeout(hideTimeout);
                    }
                });
            }

            /**
             * Add accessible tabbing to anchors
             */
            context.find('[data-binding="navigation-item"] > a').off('click focus').on({
                click: function click(e) {
                    desktopAddHover($(this).parent());
                    if ('tablet' === getDeviceType() && (!tabletMegaNavOpened || tabletMegaNavOpenedLink !== $(e.target).attr('href'))) {
                        e.preventDefault();
                        tabletMegaNavOpened = true;
                        tabletMegaNavOpenedLink = $(e.target).attr('href');
                    }
                },
                focus: function focus() {
                    if ('desktop' === getDeviceType()) {
                        desktopAddHover($(this).parent());
                    }
                }
            });

            context.find('[data-binding="navigation-item"]').off('focusin focusout');
            if ('desktop' === getDeviceType()) {
                context.find('[data-binding="navigation-item"]').on({
                    focusin: function focusin() {
                        desktopAddHover($(this));
                    },
                    focusout: function focusout() {
                        // timeout as on focusout no element is focused
                        setTimeout(function () {
                            // check if there's still focus in one of the sub-items
                            if ($('[data-binding="navigation-item"] :focus').length === 0) {
                                // ...remove any previously opened hovers if we are outside mega-nav
                                // (if the focus is still within mega-nav the desktopAddHover function
                                // will remove hover anyway)
                                context.find('[data-binding="navigation-item"]').removeClass(hoverClass).attr('aria-hidden', ' true');
                            }
                        }, 0);
                    }
                });
            }

            // listen for keyboard input within the meganav context
            context.off('keyup');
            if ('desktop' === getDeviceType()) {
                context.on('keyup', function (e) {
                    var keyboard = {
                        LEFT: 37,
                        RIGHT: 39
                    };
                    var $newFocusElement;

                    if (e.which === keyboard.LEFT) {
                        // find the previous sibling of the current navigation-item
                        $newFocusElement = $(e.target).closest('[data-binding="navigation-item"]').prev();
                    }

                    if (e.which === keyboard.RIGHT) {
                        // find the next sibling of the current navigation item
                        $newFocusElement = $(e.target).closest('[data-binding="navigation-item"]').next();
                    }

                    if (e.which === keyboard.LEFT || e.which === keyboard.RIGHT) {
                        // check if the new focus candidate is a meganav item
                        if ($newFocusElement.attr('data-binding') === 'navigation-item') {
                            // run on the next event loop to circumvent a Chrome-related bug
                            (function ($focusElement) {
                                setTimeout(function () {
                                    // find a focusable link within the navigation item
                                    var $focusableLink = $focusElement.find('> a');
                                    if ($focusableLink.length > 0) {
                                        // set the focus for the focusable link (equivalent of pressing Tab)
                                        $focusableLink.focus();
                                        // set focusin event for the whole navigation item to keep it opeened
                                        $focusElement.trigger('focusin');
                                    }
                                }, 0);
                            })($newFocusElement);
                        }
                    }

                    //console.log(e.which);
                });
            }
        }
    }

    /**
     * Set the nav height
     */
    function setNavHeight() {

        /// Desktop first
        if (isMobile === false) {
            /// Mouseover of primary nav links
            $('.navigation__nav-item').mouseover(function () {
                var $tierTwoItems = $(this).find('.navigation-tier-two__nav-item');
                var $tierTwo = $(this).find('.navigation-tier-two');
                var height = 0;
                var itemHeight = 0;
                var i;

                /// loop through chldren within hovered item and find tallest
                for (i = 0; i < $tierTwoItems.length; i++) {
                    itemHeight = $($tierTwoItems[i]).children('.nav-tier-three').outerHeight();
                    if (itemHeight > height) {
                        height = itemHeight;
                    }
                }

                /// If tallest item is taller than overall nav, then set the height
                if (height > $tierTwo.outerHeight()) {
                    $tierTwo.css('height', height);
                    $tierTwoItems.children('.nav-tier-three').css('height', height);
                } else {
                    $tierTwoItems.children('.nav-tier-three').css('height', $tierTwo.outerHeight());
                }
            });
        } else {
            $('.navigation__nav-item').unbind();
            $('.navigation-tier-two').css('height', 'auto');
            $('.nav-tier-three').css('height', 'auto');
        }
    }

    /**
     * Set toggle behaviour for mobile versions
     */
    function setNavMobileEvents() {
        var $toggle = $offCanvasNavigation.find('.toggle, [data-binding="toggle"]');

        $toggle.off('click').on('click', function (e) {
            var $toggled = $(e.target).data('binding') === 'toggle' ? $(this) : $(this).parent();
            if ($toggled.hasClass('is-open')) {
                $toggled.next('ul').slideUp();
                $toggled.removeClass('is-open');
            } else {
                $toggled.next('ul').slideDown();
                $toggled.addClass('is-open');
            }

            if (isMobile) {
                e.preventDefault();
            }

            // prevent any further firing of this event
            e.stopImmediatePropagation();
        });
    }

    /**
     * Open slideout nav
     */
    function openNav() {
        $innerWrapper.addClass('is-open');
        $toggleNavButton.addClass('close').closest('.navigation').addClass('opened');
        $offCanvasNavigation.find('.inner').addClass('is-open');
    }

    /**
     * Close slideout nav
     */
    function closeNav() {
        $innerWrapper.removeClass('is-open');
        $toggleNavButton.removeClass('close').closest('.navigation').removeClass('opened');
        $offCanvasNavigation.find('.inner').removeClass('is-open');
    }

    /**
     Init
     */
    function init() {
        /// Check if mobile
        if ($innerWrapper.find('.navigation-tier-two').css('position') === 'relative') {
            isMobile = true;

            setNavMobileEvents();
        }

        setNavEvents();

        setNavHeight();

        /// Add class to enable css animations
        $offCanvasNavigation.addClass('enable-animation');

        /// Check tier two items for children
        hasChildren('navigation-tier-two__nav-item', 'nav-tier-three');

        /**
         * Mobile Nav
         */

        /// Add open and close buttons
        $offCanvasNavigation.prepend($toggleNavButton);
        $innerWrapper.prepend($contentMask);

        /// Open and close nav with main "menu" button (moble)
        $toggleNavButton.on('click', function () {
            if ($innerWrapper.is('.is-open')) {
                closeNav();
            } else {
                if ($openSearchButton.hasClass('is-open')) {
                    $openSearchButton.click();
                }
                openNav();
            }
        });

        /// Close nav by clicking  mask over content
        $contentMask.on('click', function () {
            closeNav();
        });

        // Open search box on click search button
        $openSearchButton.on('click', function () {
            if ($toggleNavButton.hasClass('close')) {
                $toggleNavButton.click();
            }

            $(this).closest('.desktop').toggleClass('is-open');
            context.find('.site-header').toggleClass("site-header-big");

            if (searchOpened = !searchOpened) {
                var searchInput = context.find('#search-main-nav');
                var searchVisibilityInverval = setInterval(function () {
                    if (searchInput.is(':visible')) {
                        searchInput.focus();
                        clearInterval(searchVisibilityInverval);
                    }
                }, 10);
            }
        });

        // Close search form on click X button
        $closeSearchButton.on('click', function () {
            context.find('.site-header__search-form .link').click();
        });

        if (navigator.geolocation) {
            context.find('[data-binding="reserves-meganav-near-me-search"]').show();
            $(document).on('click', '[data-binding="reserves-meganav-location"]', function (e) {
                e.preventDefault();
                navigator.geolocation.getCurrentPosition(function (position) {
                    dataLayer.push({ 'event': 'reserveMeganavSearch', 'reserveSearchTerm': 'NearMe' });
                    context.find('[data-binding="reserve-meganav-postcode"]').val(position.coords.latitude + ',' + position.coords.longitude);
                    context.find('[data-binding="reserve-meganav-search"]').submit();
                });
            });
        }

        context.find('[data-binding="reserve-meganav-custom-search"]').on('click', function (e) {
            e.preventDefault();
            dataLayer.push({ 'event': 'reserveMeganavSearch', 'reserveSearchTerm': $(this).prev().val() });
            context.find('[data-binding="reserve-meganav-search"]').submit();
        });

        $(window).resize(function () {

            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(function () {
                /// Check if desktop - if so remove all styles
                if ($innerWrapper.find('.navigation-tier-two').css('position') === 'relative') {
                    isMobile = true;
                    $innerWrapper.find('.toggle, [data-binding="toggle"]').removeClass('is-open').removeAttr('style');
                } else {
                    isMobile = false;

                    closeNav();
                    $innerWrapper.find('.navigation .is-open').removeClass('is-open');
                    context.find('.navigation ul').removeAttr('style');
                }

                // after resetting
                setNavEvents();
                if (isMobile) {
                    setNavMobileEvents();
                }
                setNavHeight();
            }, 250);
        });
        $(document).on('click', function (e) {
            e.stopPropagation();
            if (isMobile === false && context.find('.navigation__nav-item').hasClass(hoverClass)) {
                if (!$(e.target).closest('.navigation').length) {
                    context.find('.navigation__nav-item').removeClass(hoverClass).attr('aria-hidden', 'true'); // remove any previously opened hovers
                    clearTimeout(hideTimeout); // clear the pending hide
                }
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/navigation.js
// module id = 181
// module chunks = 0